import { SITE_NAME } from "../constants/site";

const replaceBrand = (value, key) => {
  if (typeof value === "string") {
    if (key === "projectSmartHealth") {
      return value;
    }
    return value
      .replaceAll("臺灣智慧醫療學校", SITE_NAME)
      .replaceAll("臺灣智慧醫療學校", SITE_NAME)
      .replaceAll("Taiwan Smart Healthcare School", SITE_NAME)
      .replaceAll("Smart Healthcare School", SITE_NAME);
  }

  if (Array.isArray(value)) {
    return value.map((val) => replaceBrand(val, key));
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, val]) => [k, replaceBrand(val, k)])
    );
  }

  return value;
};

const messages = {
  common: {
    loading: '載入內容中...',
    retry: '重試',
    all: '全部',
    submit: '送出',
    clearAll: '全部清除',
    home: '首頁',
    allCourses: '所有課程',
    fourDomains: '四大領域學程',
    seminarArea: '研討會專區',
    notSpecified: '未指定',
    pleaseLogin: '請先登入',
    systemError: '系統錯誤，請稍後再試',
    instructor: '講師',
    download: '下載',
    exportSuccess: '匯出成功',
    exportFailed: '匯出失敗，請稍後再試',
    downloadSuccess: '證書下載成功',
    certificateNotFound: '找不到指定的證書',
    noPermission: '您沒有權限下載此證書',
    downloadFailed: '下載失敗，請稍後再試',
    networkError: '下載時發生錯誤，請檢查網路連線',
    initFailed: '初始化資料失敗:',
    invalidDownloadLink: '下載連結無效',
    preparingDownload: '正在準備下載證書...',
    loginAgain: '重新登入',
    levelBeginner: '初階',
    levelIntermediate: '中階',
    levelAdvanced: '高階',
    mandatory: '必修',
    optional: '選修',
    unknownError: '未知錯誤',
    to: '至',
    dateLocale: 'zh-TW',
    scoreUnit: '分',
    minutesUnit: '分鐘',
    uploadFailed: '上傳失敗',
    questionsUnit: '題',
    unknown: '未知',
    gotIt: '知道了',
    courseListDesc: '此為培訓計畫之必選修課程，請登入後開始課程。有興趣加入線上學習行列的產官學研醫人士，可前往',
    infoSecurityListDesc: '此為培訓計畫之必修課程，請登入後開始課程。',
    area4Desc: '此為培訓計畫之必修課程，請登入後開始課程。',
    area4DescOpt: '此為培訓計畫之選修課程，請登入後開始課程。',
    tocLabel: '段落導覽',
    scrollHint: '左右滑動以瀏覽更多資訊'
  },
  latest_news: {
    title: '最新消息',
    all: '全部',
    announcement: '公告',
    activity: '活動',
    read_more: '閱讀更多',
    register: '前往報名',
    more_info: '更多資訊'
  },
  activities: {
    home: '首頁',
    title: '最新消息',
    announcement: '公告',
    activity: '活動',
    read_more: '閱讀更多',
    register: '前往報名',
    more_info: '詳細資訊',
    activity_time: '活動時間',
    location: '活動地點',
    register_link: '點擊前往報名',
    course_link: '點擊查看詳情',
    not_found: '找不到此活動或公告',
    back_to_list: '返回列表',
    not_open_yet: '尚未開始報名',
    ended: '活動已結束',
    registration_closed: '報名已截止'
  },
  certificate: {
    title: '修課證明下載',
    subtitle: '完成任一課程後即可下載該課程修課證明',
    emptyText: '您還沒有獲得任何證書，請繼續完成課程獲得證書！',
    of: '共',
    userInfoError: '無法取得用戶資訊，請重新登入',
    invalidDownloadLink: '下載連結無效',
    preparingDownload: '正在準備下載證書...',
    downloadSuccess: '證書下載成功',
    certificateNotFound: '找不到指定的證書',
    downloadPermissionDenied: '您沒有權限下載此證書',
    downloadFailed: '下載失敗，請稍後再試',
    downloadNetworkError: '下載時發生錯誤，請檢查網路連線',
    invalidCertificateData: '未獲取到有效的證書資料',
    fetchCertificateListError: '獲取證書列表失敗',
    certificateName: '證書名稱',
    instructor: '講師',
    credits: '學分',
    completionDate: '完成日期',
    download: '下載'
  },
  examInfo: {
    title: '準備進行測驗',
    description: '您好，請詳閱以下作答注意事項後開始作答，可按「下次再來」離開。',
    examName: '測驗名稱',
    totalScore: '總分',
    totalQuestions: '總題數',
    examPeriod: '作答起止日期時間',
    examDuration: '考試時間',
    scoringMethod: '計分方式',
    questionsPerPage: '顯示題數',
    pageControl: '翻頁控制',
    windowControl: '視窗控制',
    timeoutHandling: '逾時處理',
    answerReveal: '公布答案',
    questionsPerPageFormat: '每頁{count}題',
    unlimited: '無限期',
    cancelButton: '下次再來',
    startButton: '開始作答',
    loadingExamInfo: '準備測驗中...',
    examReady: '測驗已準備就緒',
    examCreationFailed: '測驗建立失敗，請稍後再試',
    examInfoLoadFailed: '無法載入測驗資訊，請重試',
    uploadFailed: '上傳失敗',
    examStartFailed: '啟動測驗失敗',
    photoUploadFailed: '照片上傳失敗，具體錯誤:'
  },
  examHistory: {
    title: '測驗成績查詢',
    subtitle: '查詢課程成績',
    emptyText: '您尚未參加任何課程測驗，請在完成課程後進行測驗！',
    of: '共',
    userInfoError: '無法取得用戶資訊，請重新登入',
    pass: '及格',
    fail: '不及格',
    retake: '重新作答',
    backToCourse: '回到課程',
    courseName: '課程名稱',
    instructor: '講師',
    credits: '學分',
    examDate: '測驗日期',
    score: '分數',
    passStatus: '及格',
    action: '操作',
    invalidUserData: '未返回有效的用戶資料',
    fetchUserInfoError: '獲取用戶資訊失敗，請重新登入',
    invalidExamData: '未獲取到有效的測驗歷史資料',
    fetchExamHistoryError: '獲取測驗歷史失敗',
    redirectingToCourse: '正在導向課程頁面...',
    courseInfoError: '無法取得課程資訊'
  },
  navbar: {
    home: '首頁',
    planOrigin: '計畫緣起',
    seminar: '研討會專區',
    planCourses: '徵案必修課程',
    fourDomains: '四大領域學程',
    allCourses: '所有課程',
    medicalInfo: '醫療資訊學程',
    medicalAI: '醫療AI學程',
    medicalSecurity: '醫療資安學程',
    medicalBigData: '醫療大數據學程',
    login: '登入',
    register: '註冊',
    dashboard: '儀表板',
    profile: '帳號設定',
    inProgress: '進行中',
    completed: '已完成',
    favorites: '收藏',
    certificates: '修課證明下載',
    exams: '測驗成績查詢',
    editProfile: '編輯個人資料',
    logout: '登出',
    myCourses: '我的課程',
    myLearningRecord: '我的學習紀錄',
    myAccount: '我的帳戶',
    language: '語言',
    traditionalChinese: '繁體中文',
    english: 'English',
    introAndHistory: '簡介與沿革',
    ministerIntro: '部長的話',
    viceMinisterIntro: '次長的話',
    directorIntro: '處長的話',
    isOptional: '選修課程',
    latestNews: '最新消息',
    platformIntro: '簡介與沿革',
    platformBackground: '成立背景',
    expertDirectory: '專家名錄',
    snomedCtIntro: 'LOINC介紹',
    whatIsSnomedCt: '什麼是LOINC',
    snomedCtEducation: 'LOINC教育專區',
    loincIntro: 'LOINC介紹',
    loincEducation: 'LOINC教育專區',
    training: '培訓認證',
    workshopCourses: '工作坊課程',
    workshopMaterials: '工作坊官方教材',
    certificationApply: '認證申請專區',
    taiwanStandards: '臺灣標準',
    standardAnnouncements: '標準公告區',
    standardProposals: '標準提案區',
    datasets: '資料集',
    terminologySearch: '術語搜尋',
    terminologyTaiwan: '臺灣版',
    terminologyInternational: '國際版',
    supportCenter: '支援中心',
    projectWebsites: '計劃網站',
    projectMedStandard: '臺灣醫療資訊標準大平台',
    projectThds: '臺灣健康資料空間',
    projectThrs: '臺灣健康規則空間',
    projectThas: '臺灣健康應用空間',
    projectSnomedCt: 'SNOMED CT',
    projectLoinc: 'LOINC',
    projectRxNorm: 'RxNorm',
    projectSmartHealth: '臺灣智慧醫療學校',
    projectAiCenter: '臺灣智慧醫療三大中心',
    projectAiCenter1: '全國臨床AI應用登錄平台',
    projectAiCenter2: '全球醫療 AI 聯邦學習媒合平台'
  },
  snomedCT: {
    title: '什麼是 LOINC',
    section1: {
      title: '什麼是 LOINC'
    },
    section2: {
      title: 'LOINC 如何使用 ?',
      conceptsTitle: '概念（Concepts）：',
      descriptionsTitle: '描述（Descriptions）：'
    }
  },
  loincIntro: {
    paragraph1:
      'LOINC（Logical Observation Identifiers Names and Codes），觀測指標標識符邏輯命名與編碼系統，由美國聯邦機構和組織資助，在 Regenstrief 創建和維護。針對醫療情境中，對於所有具有可推論性的觀察所得賦予一個具有名稱與編碼的辨識碼， LOINC 術語涉及用於臨床醫療護理、結果管理和臨床研究等目的的各種臨床觀測指標。',
    paragraph2:
      'LOINC 編碼方式係由六個軸向所組成，除 LOINC 代碼外，涵括的資訊尚有檢驗項目名稱、測量單位屬性、檢驗時間屬性、檢體種類、檢驗單位屬性、及檢驗方法等。',
    diagramAlt: 'LOINC 編碼方式示意圖'
  },
  snomedCTEducation: {
    title: 'SNOMED CT 教育專區',
    articleTitle: 'SNOMED CT 課程影片',
    navDivider: '...',
    description: '想更深入認識 SNOMED CT 嗎？您可前往「臺灣智慧醫療學校」的「研討會專區」，瀏覽相關課程影片，無須註冊即可直接觀看。',
    ctaLabel: '前往臺灣智慧醫療學校',
    application: {
      title: 'SNOMED CT 應用',
      paragraph1: '一般內容文字用黑色',
      highlight: '特殊 highlight 字用藍色',
      codeAlt: 'FHIR Patient 資源範例',
      codeCaption: '（圖片來源：HL7）'
    },
    expression: {
      title: 'SNOMED CT 表達式',
      paragraph1: '...'
    },
    videos: {
      title: 'SNOMED CT 課程影片',
      description: '想更深入認識 SNOMED CT 嗎？您可前往「臺灣智慧醫療學校」的「研討會專區」，瀏覽相關課程影片，無須註冊即可直接觀看。',
      ctaLabel: '前往臺灣智慧醫療學校 '
    }
  },
  loincEducation: {
    title: 'LOINC 教育專區',
    application: {
      title: 'LOINC 應用',
      paragraph1: '一般內容文字用黑色',
      highlight: '特殊 highlight 字用藍色',
      codeAlt: 'LOINC 術語範例',
      codeCaption: '（資料來源：LOINC）'
    },
    expression: {
      title: 'LOINC 表達式',
      paragraph1: '...'
    },
    videos: {
      title: 'LOINC 課程影片',
      description: '想更深入認識 LOINC 嗎？您可前往「臺灣智慧醫療學校」的「研討會專區」，瀏覽相關課程影片，無須註冊即可直接觀看。',
      ctaLabel: '前往臺灣智慧醫療學校 '
    }
  },
  footer: {
    planOrigin: '計畫緣起',
    seminar: '研討會專區',
    planCourses: '徵案必修課程',
    fourDomains: '四大領域學程',
    termsAndPolicies: '隱私權政策及會員服務條款',
    termsOfService: '隱私權政策及會員服務條款',
    allCourses: '所有課程',
    medicalInfo: '醫療資訊學程',
    medicalAI: '醫療AI學程',
    medicalSecurity: '醫療資安學程',
    medicalBigData: '醫療大數據學程',
    securityPolicy: '隱私權政策及會員服務條款',
    privacyPolicy: '隱私權政策及會員服務條款',
    privacyAndTerms: '隱私權政策及會員服務條款',
    schoolName: '臺灣智慧醫療學校',
    introAndHistory: '簡介與沿革',
    ministerIntro: '部長的話',
    viceMinisterIntro: '次長的話',
    directorIntro: '處長的話',
    customerService: '支援表單',
    latestNews: '最新消息',
    platformIntro: '簡介與沿革',
    platformBackground: '成立背景',
    expertDirectory: '專家名錄',
    snomedCtIntro: 'LOINC介紹',
    whatIsSnomedCt: '什麼是LOINC',
    snomedCtEducation: 'LOINC教育專區',
    training: '工作坊課程',
    workshopCourses: '工作坊課程',
    workshopMaterials: '工作坊官方教材',
    certificationApply: '認證申請專區',
    taiwanStandards: '臺灣標準',
    standardAnnouncements: '標準公告區',
    standardProposals: '標準提案區',
    datasets: '資料集',
    terminologySearch: '術語搜尋',
    terminologyTaiwan: '臺灣版',
    terminologyInternational: '國際版',
    supportCenter: '支援中心'
  },
  examModal: {
    title: '開始測驗前，請注意以下事項',
    cameraInstruction: '請確認畫面顯示清楚，若為黑畫面請檢查鏡頭設定',
    cameraError: '無法啟用相機',
    retryCamera: '重試',
    safetyRules: {
      rule1: '1.在測驗期間，將透過您的攝影機進行拍照，以確認為本人作答。',
      rule2: '2.拍攝僅用於本次測驗身份驗證，不另作他用，並依平台',
      rule3: '3.請確保臉部清晰可見，並避免背景出現敏感資訊或干擾物。',
      rule4: '4.若裝置無法啟用攝影機，將無法進行本次測驗。',
      rule5: '5.測驗期間若偵測不到攝影機，系統將自動暫停作答，請確保全程順利拍攝。'
    },
    privacyPolicy: '隱私政策',
    privacyPolicy2: '妥善保管',
    cancelButton: '返回前頁',
    startButton: '同意並開始測驗',
    cameraPermissionError: '無法完成拍照，請確認相機權限'
  },
  courseMonitoringModal: {
    title: '開始上課前，請注意以下事項',
    cameraInstruction: '請確認畫面顯示清楚，若為黑畫面請檢查鏡頭設定',
    cameraError: '無法啟用相機',
    retryCamera: '重試',
    safetyRules: {
      rule1: '1.在上課期間，將透過您的攝影機進行拍照，以確認為本人聽課。',
      rule1_1: '請確保臉部清晰可見，並避免背景出現敏感資訊或干擾物。',
      rule1_2: '測驗期間若偵測不到攝影機，系統將自動暫停作答，請確保全程順利拍攝。',
      rule2: '2.拍攝僅用於本次考試身份驗證，不另作他用，並依平台',
      rule3: '3.若裝置無法啟用攝影機，將無法進行本次測驗。',
      rule4: '4.觀看過程中，系統會隨機跳出確認視窗，確保您在線上課。',
      rule5: '5.觀看時長須達到影片時長，才可進行測驗，請完整觀看課程內容。'
    },
    privacyPolicy: '隱私政策',
    privacyPolicy2: '妥善保管',
    cancelButton: '返回前頁',
    startButton: '同意並開始上課'
  },
  planOrigin: {
    title: '計畫緣起',
    keyPerson: {
      photoAlt: '技監兼處長照片'
    },
    error: {
      loadFailed: '獲取計畫緣起內容失敗',
      loadError: '獲取計畫緣起內容時發生錯誤'
    }
  },
  directorIntro: {
    title: '處長的話',
    keyPerson: {
      title: '衛生福利部資訊處 技監兼處長',
      name: '李建璋',
      engName: 'Chien-Chang Lee'
    },
    section1: {
      title: '未來是軟體定義醫療服務的年代',
      content: '未來是一個軟體來定義醫療服務的一個年代，所以你可以想像，當一家醫院蓋好了以後，只要有一個軟體裝上去，除了幫助醫師來寫病歷，指導醫師來診斷用藥，甚至還可以判讀影像，如果要實現這一切，我們一定要有跨領域的人才。過去跨領域人才培養歷程相當漫長，他需要學習醫學知識，同時還要學習醫療資訊學、AI、大數據的相關知識，所以動輒養成期間都超過10年以上，趕不上目前我們實際的需求。所以歐美國家，大部分的醫院都有設置醫療資訊長的職務。'
    },
    section2: {
      title: '醫療資訊長的四大角色',
      content: '最近幾年來，甚至醫療資訊長還細分成四大角色，第一種角色是醫療資安長，負責維護醫療資安環境，第二種是醫療資訊長，就是以電子病歷為中心來處理臨床決策系統，還有電子病歷互通內容，第三種叫做醫療大數據長，數據是智慧醫療的石油，這些數據需要治理，所以設立醫療大數據長來處理這些內容，最後1個是醫療AI長，我們知道AI技術進步非常快，AI也面臨很多倫理和落地的議題，也需要有一個跨領域的人來處理這些事情，但這些內容很難在單一的1個學校的1個學程裡來完成訓練，他必須要結合線上教育訓練，甚至還要能夠動手實現，這樣才稱得上是一個完整的訓練。'
    },
    section3: {
      title: '臺灣智慧醫療學校的訓練模式',
      content: '所以資訊處就來組織這樣的訓練課程，我們透過跟國際上著名的智慧醫療醫院一起合作，學員在線上完成教育之後，通過甄選，可到國外醫院實習，回來臺灣，就在自己的醫療場域做落地工作，這樣才算完成完整的訓練課程，衛福部就可以頒予相關資格。成立臺灣智慧醫療學校為各大醫院充實跨領域人才，為國家智慧醫療打下良好的基礎。'
    }
  },
  ministerIntro: {
    title: '部長的話',
    paragraph1: '面對全球醫療快速走向智慧化，我們正站在一個關鍵的轉折點。醫療服務已不再只是臨床現場的診斷與治療，更逐漸轉向以「資料」與「科技」為核心的決策模式。從電子病歷的互通、醫療AI的應用、大數據分析到臨床決策支援系統，每一項技術都正在重新定義醫療的樣貌。而要讓這些創新真正落地、改善病人的照護品質，「人才」是最重要的基礎。',
    paragraph2: '臺灣在醫療品質與公共衛生資訊整合上擁有長期累積的優勢，但在高速變動的技術環境中，仍需要更多能跨越臨床與科技邊界的人才，協助醫療機構推動數位轉型。也因此，我們啟動了「臺灣智慧醫療學校」，一個能夠系統化培養醫療資訊與智慧醫療專業人才的國家級平台。',
    paragraph3: '這個平台結合國內外專業線上課程、AI互動測驗與數位認證，讓學員能隨時隨地學習智慧醫療的核心能力；同時也透過與國際頂尖醫院的合作，建立跨國實務訓練與人才交流的機制。未來，臺灣的醫療資訊人才將藉由這個平台將走向國際，把世界最新的智慧醫療思維與經驗帶回臺灣，轉化為臨床的實際改變。',
    paragraph4: '智慧醫療的推動是一條長路，但也是臺灣邁向全球領先的重要契機，期許「臺灣智慧醫療學校」成為集結專家、培育人才與促進跨界合作的平台，讓每一位醫療照護者，都能在科技的加值下提供更精準、更安全、更以病人為中心的醫療服務。',
    paragraph5: '邀請大家與我們一起，打造引領未來世代的智慧醫療新生態。',
    keyPerson: {
      title: '衛生福利部 部長',
      name: '石崇良',
      engName: 'Chung-Liang Shih'
    }
  },
  viceMinisterIntro: {
    title: '次長的話',
    paragraph1: '醫療數位轉型不只是技術的升級，更是整體醫療體系的重新調整。近年來，我們看到許多醫院在電子病歷、資訊安全、資料治理及AI應用上都面臨新的挑戰，也因此，我們更清楚理解到：唯有具備跨領域能力的人才，才能真正讓智慧醫療在第一線落地。',
    paragraph2: '「臺灣智慧醫療學校」正是基於這樣的需求而成立。這不僅是一個線上教育平台，而是結合政策方向、國際經驗與臨床需求所建構的完整培訓體系。課程涵蓋醫療資安、醫療大數據、醫療AI、醫療資訊管理四大領域，並透過AI互動測驗與情境式學習，讓學員不只是「知道」，而是真正能「做到」。',
    paragraph3: '這個平台也將人才培育與制度設計結合，以「培訓認證」與「國際實務訓練」為雙主軸，提供學員一條清晰的成長路徑。在完成課程與認證後，表現優異的學員將可赴國外醫院接受實務訓練，學習如何在臨床環境中推動資料治理、臨床AI或各式創新的智慧醫療應用。',
    paragraph4: '我相信，「臺灣智慧醫療學校」將成為醫院數位轉型的重要推力，也為臺灣醫療體系帶來新的能量。透過制度化、長期化與跨國合作的人才培育模式，我們將逐步建構一個能支持AI時代醫療需求的專業生態系，讓每一家醫院在面對快速變動的科技時，都能具備足夠的人才與能力，安心往前走。',
    paragraph5: '期待每一位加入智慧醫療學校的學員，都能成為引領臺灣智慧醫療發展的核心人才，讓我們攜手開創更安全、更具品質的健康環境。',
    keyPerson: {
      title: '衛生福利部 常務次長',
      name: '莊人祥',
      engName: 'Jen-Hsiang Chuang'
    }
  },
  allCourses: {
    browseByCategory: '按課程分類瀏覽'
  },
  courseDetail: {
    courseDetail: '課程詳情',
    noNeedsRegistration: '註：非培訓計畫學員無需註冊也可聽課，僅無法累計學分',
    courseIdNotFound: '找不到課程 ID',
    enrollNow: '立即報名',
    continueLearning: '繼續上課',
    takeExam: '進行測驗',
    viewRecord: '查看紀錄',
    favorite: '收藏',
    favorited: '已收藏',
    courseCategory: '課程類別',
    courseUser: '課程使用者',
    courseInstructor: '課程講師',
    credits: '學分數',
    courseLevel: '課程等級',
    certificateIssued: '證書發放',
    hasCertificate: '有證書',
    noCertificate: '無證書',
    courseIntro: '工作坊介紹',
    timeLocation: '時間地點',
    workshopAgenda: '工作坊議程',
    intro: '介紹',
    chapterList: '單元一覽',
    chapter: '單元',
    aboutInstructor: '關於講師',
    instructor: '講師',
    getCertificate: '獲得證書',
    certificate: '證書',
    totalDuration: '總時長：',
    noChaptersSet: '本課程尚未設定章節內容',
    uncategorized: '未分類',
    is_mandatory: '性質',
    mandatory: '必修',
    optional: '選修',
    failedToGetCourseData: '無法獲取課程數據',
    errorGettingCourseDetail: '獲取課程詳情時發生錯誤',
    pleaseLoginToEnroll: '請先登入後再進行報名',
    noAvailableChapterFound: '無法找到可學習的章節',
    cmioCourseRequiresCompleteProfile: 'CMIO課程報名需要完整的個人資料',
    enrollmentFailed: '報名失敗，請重試',
    pleaseAgreeToTerms: '請勾選同意條款後再繼續',
    courseContentLoaded: '課程內容已載入',
    failedToLoadCourseContent: '加載課程內容失敗，請重試',
    preparingToStartCourse: '準備開始上課...',
    enteringCourse: '正在進入課程...',
    certificateIssuance: '證書發放',
    getCertificate: '累積學分',
    noInstructorData: '本課程尚未提供講師資料',
    formalLearningRecord: '可做為正式學習紀錄',
    enhanceResume: '可列入個人履歷，提升職業競爭力',
    youWillGetCertificate: '完成本課程後，可累積學分',
    notYetExam: '尚未滿足測驗要求'
  },
  findCourse: {
    courseCatelog: '找到適合你的課程',
    nature: '性質',
    creditUnit: '學分',
    creditRange: '學分數範圍',
    courseTopic: '課程主題',
    sortNewest: '排序：最新',
    sortPopular: '排序：熱門',
    sortName: '排序：名稱',
    filter: '篩選',
    sort: '排序',
    popular: '熱門',
    newest: '最新',
    name: '名稱',
    beginner: '初階',
    intermediate: '中階',
    advanced: '高階',
    noLevel: '不分等級',
    credit: '學分',
    topic: '主題',
    mandatory: '必修',
    optional: '選修',
    noRegistrationCourse: '免註冊課程',
    CMIOCourse: 'CMIO課程',
    noMatchingCourses: '沒有找到匹配的課程。請嘗試不同的篩選選項。',
    getFavoriteCoursesFailed: '獲取收藏課程失敗'
  },
  home: {
    carousel: {
      welcomeTitle: '歡迎來到臺灣智慧醫療學校',
      welcomeSubtitle: '資料驅動的智慧醫療',
      retry: '重試'
    },
    snomedCt: {
      title: '什麼是 LOINC？',
      subtitle: 'LOINC (Logical Observation Identifiers Names and Codes)',
      desc1: '用於標準化檢驗、觀察與臨床量測的識別碼與名稱體系。',
      desc2: '促進跨系統、跨機構的資料交換與一致性表達。',
      featuresTitle: 'LOINC 的特色',
      features: {
        f1: {
          title: '標準化檢驗與觀察',
          desc: '將檢驗項目、量測與臨床觀察以一致的代碼與命名表達，降低不同系統間的理解落差。'
        },
        f2: {
          title: '支援互通與交換',
          desc: '讓不同醫療系統能正確傳遞與解讀檢驗/觀察資料，提升跨院、跨系統的資訊流通效率。'
        },
        f3: {
          title: '可延伸多元應用',
          desc: '可應用於臨床決策支援、研究分析與公共衛生，支持資料再利用與進階分析。'
        }
      },
      learnMore: '了解更多'
    },
    trainingCert: {
      title: '培訓認證',
      workshops: {
        title: '工作坊課程',
        desc: '【需要請建儒提供簡介文字】',
        btn: '前往課程'
      },
      materials: {
        title: '工作坊官方教材',
        desc: '【需要請建儒提供簡介文字】',
        btn: '前往教材'
      },
      certification: {
        title: '認證申請專區',
        desc: '【需要請建儒提供簡介文字】',
        btn: '前往專區'
      }
    },
    taiwanStandard: {
      title: '臺灣標準',
      desc: '簡介文字',
      announcement: {
        title: '標準公告區',
        desc: '本區發布由 Regenstrief 研究所創建與維護之 LOINC (Logical Observation Identifiers Names and Codes) 最新動態，及國內代碼對應更新。LOINC 為全球通用的觀測指標標識符邏輯命名與編碼系統，旨在為醫療情境中具可推論性的觀察所得，賦予唯一的名稱與編碼辨識碼。',
        btn: '前往標準公告區'
      },
      standardProposals: {
        title: '標準提案區',
        desc: '為了完善國內醫療觀測指標的覆蓋率，本區提供標準化提案管道。針對現行編碼(包含國際標準碼或是本土對應代碼)未涵蓋之LOINC Code，經專家審查後，可納入在地化實作指引或向國際組織提交建議。',
        btn: '前往標準提案區'
      },
      dataset: {
        title: '資料集',
        desc: '【需要請建儒提供簡介文字】',
        btn: '前往資料集'
      }
    },
    termSearch: {
      title: '術語搜尋',
      desc: '',
      international: {
        title: '國際版',
        desc: 'SearchLOINC 網頁版搜尋應用程式，提供醫療專業人員、實作者和研究人員於瀏覽器中查詢、比對及管理醫學觀察代碼。支援全文與欄位搜尋、多維度篩選及層次結構與面板瀏覽。',
        btn: '前往國際版'
      },
      taiwan: {
        title: '臺灣版',
        desc: '提供國內健保碼與LOINC間之對應以及本土化應用、暫行碼之搜尋。',
        btn: '即將推出'
      }
    }
  },
  seminar: {
    desc: '培訓計畫學員請前往四大領域學程中學習，以取得學分。'
  },
  planCourses: {
    title: '徵案必修課程',
    desc: '符合計劃的學員方能進入課程，以取得學分'
  },
  sidebar: {
    taiwanSmartHealthSchool: '臺灣智慧醫療學校',
    dashboard: '儀表板',
    certificates: '證書下載',
    myCourses: '我的課程',
    inProgressCourses: '進行中課程',
    completedCourses: '已完成課程',
    favoriteCourses: '收藏課程',
    myLearningRecord: '我的學習紀錄',
    instructor: '講師',
    trackedInstructors: '追蹤講師',
    certificateStatsAndDownload: '修課證明下載',
    examResultsQuery: '測驗成績查詢',
    user: '使用者',
    profile: '帳號設定',
    accountCenter: '帳號中心',
    logout: '登出',
    websiteHomepage: '網站首頁',
    language: '語言',
    chinese: '繁體中文',
    english: 'English'
  },
  instructor: {
    instructorPhoto: '講師照片',
    instructorName: '講師姓名',
    position: '職位',
    loadingInstructorInfo: '載入講師資訊中...',
    reloadInstructor: '重新載入',
    defaultDescription: '講師描述將在此處顯示，包含專業背景、教學經驗等相關資訊。',
    failedToLoadInstructor: '載入講師資訊失敗',
    instructorNotFound: '找不到講師資訊',
    networkError: '網路連線錯誤，請檢查網路連線後重試',
    unknownError: '發生未知錯誤，請稍後再試'
  },
  loginCard: {
    title: '登入',
    email: '電子郵件',
    emailRequired: '請輸入電子郵件',
    emailInvalid: '請輸入有效的電子郵件格式',
    emailPlaceholder: '請輸入您的電子郵件',
    password: '密碼',
    passwordRequired: '請輸入密碼',
    passwordPlaceholder: '請輸入您的密碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼',
    loginButton: '登入',
    noAccount: '還沒有帳號?',
    register: '註冊',
    loginSuccess: '登入成功！',
    checkEmail: '請檢查電子郵件',
    checkPassword: '請檢查密碼',
    accountNotFound: '帳號不存在',
    incorrectPassword: '密碼錯誤',
    tooManyAttempts: '嘗試登入次數過多，請稍後再試',
    serverNoResponse: '伺服器無回應，請檢查網路連線',
    loginRequestFailed: '登入請求發送失敗',
    loginFailed: '登入失敗，請稍後再試',
    twoFactorRequired: '登入需要雙重驗證，請輸入驗證碼',
    twoFactorTitle: '雙重驗證',
    twoFactorDescription: '請輸入您收到的驗證碼：',
    twoFactorPlaceholder: '請輸入8位數驗證碼',
    twoFactorSubmit: '確認',
    twoFactorCancel: '取消',
    twoFactorInvalid: '驗證碼錯誤或已過期',
    twoFactorTooManyAttempts: '嘗試次數過多，請稍後再試',
    resendCode: '重新發送驗證碼',
    resendCodeIn: '{seconds} 秒後可重新發送',
    resend2FAError: '無法重新發送驗證碼：缺少電子郵件地址',
    resendCodeSuccess: '驗證碼已重新發送',
    resendCodeFailed: '重新發送失敗',
    resendCodeError: '重新發送失敗，請稍後再試',
    accountNotFound: '帳號不存在',
    emailFormatError: '電子郵件格式錯誤',
    serverError: '伺服器錯誤，請稍後再試',
    resendRequestFailed: '重新發送請求失敗'
  },
  resendEmail: {
    forgotPassword: '忘記密碼',
    sendResetLinkBtn: '發送重設密碼連結',
    enterEmail: '請輸入你的電子郵件，',
    sendResetLink: '我們將發送重設密碼的連結給您。',
    email: '電子郵件',
    enterEmailPlaceholder: '請輸入電子郵件',
    backToLogin: '返回登入',
    sending: '發送中...',
    pleaseEnterEmail: '請輸入電子郵件',
    resetLinkSent: '重設密碼連結已發送到您的信箱',
    sendResetLinkFailed: '發送重設密碼連結失敗',
    sendResetLinkError: '發送重設密碼連結時發生錯誤'
  },
  resetPwd: {
    title: '重設密碼',
    subtitle: '請輸入新密碼（至少8個字元，並包含大小寫字母、數字及特殊符號）',
    password: '新密碼',
    confirmPassword: '確認密碼',
    passwordRequired: '請輸入新密碼',
    confirmPasswordRequired: '請再次輸入新密碼',
    passwordsNotMatch: '兩次輸入的密碼不相符',
    submitBtn: '確認重設密碼',
    submittingBtn: '重設密碼中...',
    backToLogin: '返回登入',
    successToast: '密碼重設成功',
    failedToast: '密碼重設失敗，請稍後再試',
    invalidLink: '重設密碼連結無效'
  },
  register: {
    title: '註冊共通會員帳號',
    welcome: '一組帳號，暢行多個計畫網站',
    description: 'LOINC、SNOMED CT、RxNorm 採用共通會員系統。\n您註冊完成後，無需重複申請其他網站帳號。',
    email: '電子郵件',
    emailPlaceholder: '請輸入您的電子郵件',
    password: '密碼',
    passwordPlaceholder: '請輸入您的密碼',
    passwordHint: '密碼必須至少8個字元，並包含大小寫字母、數字及特殊符號',
    registerWithEmail: '下一步：個人資料',
    termsAgreement: '繼續即表示您已詳細閱讀並同意本平台之',
    privacyPolicy: '隱私權政策及會員服務條款',
    privacyAndTerms: '隱私權政策及會員服務條款',
    and: '和',
    termsOfService: '隱私權政策及會員服務條款',
    hasAccount: '已有帳號？',
    login: '登入',
    emailRequired: '請輸入電子郵件',
    emailInvalid: '請輸入有效的電子郵件格式',
    passwordRequired: '請輸入密碼',
    passwordInvalid: '密碼必須至少8個字元，並包含大小寫字母、數字及特殊符號',
    serverError: '註冊失敗，伺服器回應格式異常',
    registerSuccess: '註冊成功！',
    registrationFailed: '註冊失敗，伺服器回應格式異常',
    networkError: '網路連線錯誤，請檢查網路連線後重試',
    stepEmail: '帳號設定',
    stepVerify: '手機驗證',
    stepProfile: '個人資料',
    stepDone: '完成註冊',
    success: '註冊成功！',
  },
  emailValidate: {
    title: '請查看您的收件匣',
    subtitle1: '點擊我們寄送至',
    subtitle2: '的連結，',
    subtitle3: '以進行您的帳戶設定。',
    openGmail: '開啟 Gmail',
    openOutlook: '開啟 Outlook',
    noEmail: '收件匣或垃圾郵件中都沒有信件？',
    resend: '重新發送',
    sending: '發送中...',
    wrongEmail: '電子郵件有誤？',
    backToRegister: '回到註冊頁',
    useOtherEmail: '並使用其他信箱註冊',
    completeRegistrationFirst: '請先完成註冊流程',
    waitSeconds: '請等待 {seconds} 秒後再重新發送',
    verificationEmailResent: '驗證電子郵件已重新發送，請查看您的收件匣',
    resendFailed: '重新發送失敗',
    resendVerificationEmailFailed: '重新發送驗證電子郵件失敗'
  },
  verifyEmail: {
    verifying: '驗證中...請稍候',
    verificationComplete: '信箱已驗證',
    welcomeMessage: '請繼續完成個人資料，完成後即可啟用共通會員帳號。',
    continueToProfile: '繼續填寫個人資料',
    continueRegistration: '繼續填寫資料完成註冊',
    verificationFailed: '驗證失敗',
    invalidLink: '請確認您的郵件連結是否有效',
    backToHome: '返回首頁',
    emailVerificationSuccess: '電子郵件驗證成功！',
    verificationFailedRetry: '驗證失敗，請重試',
    verificationError: '驗證過程中發生錯誤',
    cannotGetToken: '無法獲取 Email 驗證 Token!'
  },
  checkEmail: {
    checkYourInbox: '查看您的收件匣',
    clickLinkSentTo: '點擊我們寄送至 {email}',
    toCompleteAccountSetup: '的重設密碼連結。',
    openGmail: '開啟 Gmail',
    openOutlook: '開啟 Outlook',
    noEmailInInbox: '收件匣或垃圾郵件中都沒有信件？',
    loading: '載入中...',
    resendWithCountdown: '{countdown} 秒後重新發送',
    resend: '重新發送',
    wrongEmail: '電子郵件有誤？',
    backToForgotPassword: '返回忘記密碼頁面',
    useAnotherEmail: ' 或使用其他電子郵件',
    resetLinkResent: '重設密碼連結已重新發送到您的信箱',
    resendFailed: '重新發送失敗',
    resendError: '重新發送重設密碼連結時發生錯誤'
  },
  createAccount: {
    title: '建立身份',
    subtitle: '按照您自己的節奏，向智慧醫療專家學習。',
    name: '姓名',
    nameRequired: '請輸入您的姓名',
    namePlaceholder: '請輸入您的姓名',
    nameInvalid: '請輸入有效的姓名',
    role: '身份別',
    roleRequired: '請選擇您的身份別',
    rolePlaceholder: '請選擇您的身份',
    customRole: '自訂身份',
    customRoleRequired: '請輸入您的職業身份',
    customRolePlaceholder: '請輸入您的身份',
    source: '您從哪裡得知臺灣智慧醫療學校？',
    sourcePlaceholder: '請輸入您的得知來源',
    nextStep: '下一步',
    roleOptions: {
      doctor: '醫師',
      nurse: '護理人員',
      vendor: '廠商',
      student: '學生',
      teacher: '老師',
      other: '其他'
    },
    validation: {
      nameRequired: '請輸入有效的姓名',
      roleRequired: '請選擇您的身份別',
      customRoleRequired: '請輸入您的職業身份'
    },
    error: {
      loadRoleOptionsFailed: '無法載入身份別選項，請稍後再試'
    }
  },
  createProfile: {
    title: '建立身份',
    subtitle: '以下資訊僅於申請學分、實體證書或報名 CMIO 課程時需要，若尚無需求，可暫不填寫，日後可補登',
    photo: {
      halfLengthPhoto: '半身照',
      uploadPhoto: '上傳照片',
      removePhoto: '移除照片',
      description: '請上傳一張您的半身照，請確保清晰可辨識，僅用於確認CMIO測驗作答者為本人。',
      size: '照片尺寸：150 x 150 px',
      format: '照片格式：JPG、PNG',
      fileSize: '檔案大小：小於5MB',
      onlyJpgPng: '您只能上傳 JPG/PNG 格式的照片！',
    },
    nationality: {
      label: '國籍',
      placeholder: '請選擇您的國籍',
      helperText: '僅用於身份驗證，不另作他用',
      options: {
        // 亞洲
        taiwan: '臺灣',
        china: '中國',
        hongkong: '香港',
        macau: '澳門',
        japan: '日本',
        southKorea: '韓國',
        northKorea: '北韓',
        singapore: '新加坡',
        malaysia: '馬來西亞',
        thailand: '泰國',
        vietnam: '越南',
        philippines: '菲律賓',
        indonesia: '印尼',
        myanmar: '緬甸',
        cambodia: '柬埔寨',
        laos: '寮國',
        brunei: '汶萊',
        india: '印度',
        pakistan: '巴基斯坦',
        bangladesh: '孟加拉',
        sriLanka: '斯里蘭卡',
        nepal: '尼泊爾',
        bhutan: '不丹',
        maldives: '馬爾地夫',
        afghanistan: '阿富汗',
        iran: '伊朗',
        iraq: '伊拉克',
        israel: '以色列',
        palestine: '巴勒斯坦',
        jordan: '約旦',
        lebanon: '黎巴嫩',
        syria: '敘利亞',
        turkey: '土耳其',
        saudiArabia: '沙烏地阿拉伯',
        uae: '阿聯酋',
        kuwait: '科威特',
        qatar: '卡達',
        bahrain: '巴林',
        oman: '阿曼',
        yemen: '葉門',
        mongolia: '蒙古',
        kazakhstan: '哈薩克',
        uzbekistan: '烏茲別克',
        turkmenistan: '土庫曼',
        tajikistan: '塔吉克',
        kyrgyzstan: '吉爾吉斯',

        // 歐洲
        uk: '英國',
        ireland: '愛爾蘭',
        france: '法國',
        germany: '德國',
        italy: '義大利',
        spain: '西班牙',
        portugal: '葡萄牙',
        netherlands: '荷蘭',
        belgium: '比利時',
        luxembourg: '盧森堡',
        switzerland: '瑞士',
        austria: '奧地利',
        denmark: '丹麥',
        sweden: '瑞典',
        norway: '挪威',
        finland: '芬蘭',
        iceland: '冰島',
        russia: '俄羅斯',
        ukraine: '烏克蘭',
        belarus: '白俄羅斯',
        poland: '波蘭',
        czech: '捷克',
        slovakia: '斯洛伐克',
        hungary: '匈牙利',
        romania: '羅馬尼亞',
        bulgaria: '保加利亞',
        greece: '希臘',
        serbia: '塞爾維亞',
        croatia: '克羅埃西亞',
        slovenia: '斯洛維尼亞',
        bosnia: '波士尼亞',
        montenegro: '蒙特內哥羅',
        northMacedonia: '北馬其頓',
        albania: '阿爾巴尼亞',
        lithuania: '立陶宛',
        latvia: '拉脫維亞',
        estonia: '愛沙尼亞',
        moldova: '摩爾多瓦',
        malta: '馬爾他',
        cyprus: '賽普勒斯',
        andorra: '安道爾',
        monaco: '摩納哥',
        sanMarino: '聖馬利諾',
        vatican: '梵蒂岡',
        liechtenstein: '列支敦斯登',

        // 北美洲
        usa: '美國',
        canada: '加拿大',
        mexico: '墨西哥',
        guatemala: '瓜地馬拉',
        belize: '貝里斯',
        elSalvador: '薩爾瓦多',
        honduras: '宏都拉斯',
        nicaragua: '尼加拉瓜',
        costaRica: '哥斯大黎加',
        panama: '巴拿馬',
        cuba: '古巴',
        jamaica: '牙買加',
        haiti: '海地',
        dominicanRepublic: '多明尼加',
        bahamas: '巴哈馬',
        barbados: '巴貝多',
        trinidadTobago: '千里達及托巴哥',

        // 南美洲
        brazil: '巴西',
        argentina: '阿根廷',
        chile: '智利',
        peru: '秘魯',
        colombia: '哥倫比亞',
        venezuela: '委內瑞拉',
        ecuador: '厄瓜多',
        bolivia: '玻利維亞',
        paraguay: '巴拉圭',
        uruguay: '烏拉圭',
        guyana: '蓋亞那',
        suriname: '蘇利南',

        // 大洋洲
        australia: '澳洲',
        newZealand: '紐西蘭',
        fiji: '斐濟',
        papuaNewGuinea: '巴布亞紐幾內亞',
        samoa: '薩摩亞',
        tonga: '東加',
        vanuatu: '萬那杜',
        solomonIslands: '索羅門群島',
        micronesia: '密克羅尼西亞',
        marshallIslands: '馬紹爾群島',
        palau: '帛琉',
        nauru: '諾魯',
        kiribati: '吉里巴斯',
        tuvalu: '吐瓦魯',

        // 非洲
        southAfrica: '南非',
        egypt: '埃及',
        nigeria: '奈及利亞',
        kenya: '肯亞',
        ethiopia: '衣索比亞',
        ghana: '迦納',
        morocco: '摩洛哥',
        algeria: '阿爾及利亞',
        tunisia: '突尼西亞',
        libya: '利比亞',
        sudan: '蘇丹',
        southSudan: '南蘇丹',
        uganda: '烏干達',
        tanzania: '坦尚尼亞',
        rwanda: '盧安達',
        burundi: '蒲隆地',
        drCongo: '剛果民主共和國',
        congo: '剛果共和國',
        centralAfricanRepublic: '中非共和國',
        cameroon: '喀麥隆',
        chad: '查德',
        niger: '尼日',
        mali: '馬利',
        burkinaFaso: '布吉納法索'
      }
    },
    idNumber: {
      label: '身分證字號',
      placeholder: '請輸入您的身分證字號',
      helperText: '僅用於醫事/公務人員訓練用於學分證明，不另作他用',
      invalid: '請輸入有效的身分證字號（例如：A123456789）'
    },
    passportNumber: {
      label: '護照號碼',
      placeholder: '請輸入您的護照號碼',
      helperText: '僅用於身份確認，不另作他用',
      invalid: '請輸入有效的護照號碼（6-9位英數字組合）'
    },
    address: {
      label: '地址',
      placeholder: '請輸入您的地址',
      helperText: '僅用於正式證書寄送，不另作他用'
    },
    buttons: {
      nextStep: '下一步',
      skipStep: '跳過此步驟'
    }
  },
  verifyNumber: {
    title: '手機號碼驗證',
    subtitle: '驗證你的手機號碼，以確保帳戶的安全性與可用性',
    mobileLabel: '手機號碼',
    mobilePlaceholder: '請輸入您的手機號碼',
    sendVerification: '寄送簡訊驗證號碼',
    errorEmptyMobile: '請輸入您的手機號碼',
    errorInvalidFormat: '請輸入正確的臺灣手機號碼格式 (例如: 0912345678)',
    successMessage: '驗證碼已發送到您的手機',
    errorSubmitFailed: '提交基本資料失敗',
    errorGeneral: '操作失敗，請稍後再試',
    errorTooManyRequests: '請求過於頻繁，請稍後再試',
    errorServerError: '伺服器錯誤，請稍後再試'
  },
  verificationCode: {
    mobileLabel: '手機號碼',
    codeLabel: '簡訊驗證碼',
    codePlaceholder: '請輸入您收到的簡訊驗證碼',
    agreeText: '我已閱讀並同意',
    privacyPolicy: '隱私權政策',
    and: '和',
    termsOfService: '使用者條款',
    confirmButton: '確認並完成註冊',
    resendText: '沒有收到驗證碼？',
    checkFormValid: '請檢查表單是否正確填寫',
    resendLink: '重新發送',
    errorEmptyCode: '請輸入簡訊驗證碼',
    errorTermsNotAgreed: '請勾選同意隱私權政策和使用者條款',
    successMessage: '手機驗證成功',
    errorGetUserInfo: '獲取用戶資訊失敗:',
    errorLoginFailed: '登入失敗，請手動登入',
    errorVerificationFailed: '驗證失敗，請確認驗證碼是否正確',
    errorVerification: '驗證失敗:',
    errorGeneral: '驗證失敗，請稍後再試',
    resendSuccess: '驗證碼已重新發送',
    resendFailed: '驗證碼發送失敗，請稍後再試',
    resendError: '重新發送驗證碼失敗，請稍後再試',
    agreeToTermsHint: '請先閱讀隱私權政策和使用者條款並打勾確認'
  },
  registerComplete: {
    title: '註冊完成！',
    subtitle: '歡迎來到臺灣智慧醫療學校！',
    descriptionSteps: '在這裡，您可以跟隨智慧醫療專家們的腳步，按照自己的步調學習。',
    descriptionCourse: '您現在可以開始學習《{courseName}》',
    buttonText: '進入臺灣智慧醫療學校'
  },
  profileEdit: {
    title: '編輯個人資料',
    welcome: '歡迎您！請填寫您的個人資訊。',
    profilePhoto: '個人照片',
    userPhoto: '使用者照片',
    photoPreview: '照片預覽',
    photoDescription: '上傳清晰照片以提升您的個人資料辨識度。',
    photoSize: '建議尺寸：300x300px',
    photoFormat: '格式：所有圖片格式',
    photoFileSize: '檔案大小：最大5MB',
    removePhoto: '移除照片',
    uploadPhoto: '上傳照片',
    account: '帳號',
    accountPlaceholder: '您的帳號',
    accountHelper: '帳號無法修改',
    password: '密碼',
    passwordPlaceholder: '請輸入新密碼',
    passwordHelper: '留空則不修改密碼',
    gender: '性別',
    genderPlaceholder: '請選擇您的性別',
    genderHelper: '用於身份確認',
    genderMale: '男',
    genderFemale: '女',
    identity: '身份別',
    identityPlaceholder: '請選擇您的身份別',
    identityHelper: '用於課程推薦與證書發放',
    identityStudent: '學生',
    identityTeacher: '教師',
    identityDoctor: '醫師',
    identityNurse: '護理師',
    identityVendor: '廠商',
    identityOther: '其他',
    nationality: '國籍',
    nationalityPlaceholder: '請選擇您的國籍',
    nationalityHelper: '用於身份確認',
    nationalIdHelper: '用於身份確認',
    saveButton: '儲存',
    skipButton: '跳過',
    cancelButton: '取消',
    updateFailed: '更新失敗',
    updateFailedRetry: '更新失敗，請稍後再試',
    checkFormErrors: '請檢查表單中的錯誤訊息',
    imageFormatError: '只能上傳圖片格式的檔案！',
    imageSizeError: '圖片大小必須小於 10MB！',
    imageUploadSuccess: '照片上傳成功！',
    imageReadError: '照片讀取失敗！',
    imageRemoved: '照片已移除',
    fetchUserInfoFailed: '獲取用戶資訊失敗，請重新登入',
    unsavedChangesWarning: '您有未保存的變更，確定要離開嗎？',
    unsavedChangesConfirm: '您有未保存的變更，確定要離開嗎？離開後將會遺失所有未保存的資料。',
    passportNumber: '護照號碼',
    passportNumberPlaceholder: '請輸入您的護照號碼',
    passportNumberHelper: '用於身份確認',
    address: '地址',
    addressPlaceholder: '請輸入您的地址',
    addressHelper: '用於正式證書寄送',
    confirmButton: '確認'
  },
  dashboard: {
    welcome: 'Hi, {name}',
    welcomeSubtitle: '歡迎來到臺灣智慧醫療學校',
    student: '同學',
    completedCourses: '已完成課程',
    totalCredits: '學分數',
    certificates: '證書',
    inProgressCourses: '進行中課程',
    hotCoursesRecommendation: '熱門課程推薦',
    hotCoursesRecommendationDesc: '選一門有興趣的課程，開啟你的學習之路',
    hotCourses: '熱門課程',
    favoriteCourses: '收藏課程',
    favoriteCoursesDesc: '你已收藏 {count} 門課程，趕緊上課吧',
    favoriteCoursesEmpty: '可以從課程總覽點擊收藏你感興趣的課程',
    platformNotices: '平台消息',
    platformNoticesDesc: '隨時接收平台最新消息',
    certificateProgress: '證書進度',
    certificateProgressDesc: '完成核心課程即可獲得證書',
    certificateName: '證書名稱',
    missingCredits: '尚缺學分',
    course: '課程',
    progress: '進度',
    startLearning: '上課',
    title: '標題',
    view: '查看',
    noInProgressCourses: '目前沒有進行中的課程',
    noFavoriteCourses: '目前沒有收藏的課程',
    noNotices: '暫無平台消息',
    exploreCourses: '探索課程',
    userInfoError: '無法取得用戶資訊，請重新登入',
    relogin: '重新登入',
    currentCourses: '你目前已選修 {count} 門課程，繼續加油吧'
  },
  learningCourses: {
    title: '進行中課程',
    learningProgress: '學習進度',
    exitCourse: '退出課程',
    exploreMoreCourses: '探索更多課程',
    noCoursesFound: '找不到課程',
    userInfoError: '無法取得用戶資訊，請重新登入',
    relogin: '重新登入',
    courseRemoved: '課程已移除',
    removeCourseError: '無法刪除課程，請稍後再試',
    fetchCoursesError: '獲取進行中課程失敗',
    page: '第',
    of: '共',
    confirmExitTitle: '確定要退出課程嗎？',
    confirmExitDescription: '退出後，您的學習紀錄與測驗成績將會被清除。',
    cancel: '取消',
    confirmExit: '確認退出課程'
  },
  completeCourses: {
    title: '已完成課程',
    exportExcel: '匯出 Excel',
    nature: '性質',
    emptyDescription: '一起從進行中課程點擊繼續完成課程吧！',
    delete: '刪除',
    userInfoError: '無法取得用戶資訊，請重新登入',
    relogin: '重新登入',
    courseDeleted: '課程已刪除',
    deleteCourseError: '無法刪除課程，請稍後再試',
    fetchCoursesError: '獲取已完成課程失敗',
    noCoursesFound: '暫無已完成課程',
    courseName: '課程名稱',
    progress: '進度',
    completionDate: '完成日期',
    credits: '學分',
    actions: '操作',
    page: '第',
    of: '共'
  },
  favoriteList: {
    title: '收藏課程',
    courseName: '課程名稱',
    category: '分類',
    favoritedAt: '收藏日期',
    action: '操作',
    removeFavorite: '取消收藏',
    emptyMessage: '目前還沒有收藏任何課程',
    emptyMessageEnd: '快去收藏你喜歡的課程吧！',
    bookmarkButton: '書籤按鈕',
    of: '共',
    userInfoError: '無法取得用戶資訊，請重新登入',
    invalidUserData: '未返回有效的用戶資料',
    invalidFavoriteData: '未獲取到有效的收藏課程資料',
    fetchFavoritesError: '獲取收藏課程失敗',
    removedFromFavorites: '已取消收藏',
    removeFavoriteError: '取消收藏失敗'
  },
  trackedInstructors: {
    title: '追蹤講師列表',
    subtitle: '管理您追蹤的講師',
    emptyText: '您還沒有追蹤任何講師，快去追蹤您喜歡的講師吧！',
    instructorName: '講師姓名',
    position: '職位',
    followDate: '追蹤日期',
    action: '操作',
    unfollow: '取消追蹤',
    follow: '追蹤',
    userInfoError: '無法取得用戶資訊，請重新登入',
    followSuccess: '追蹤成功',
    unfollowSuccess: '已取消追蹤',
    operationFailed: '操作失敗',
    operationError: '操作失敗，請稍後再試',
    fetchFailed: '獲取追蹤講師列表失敗',
    fetchError: '獲取追蹤講師列表失敗，請稍後再試'
  },
  courseLearning: {
    noVideoContent: '此章節暫無影片內容',
    courseTitle: '課程標題',
    courseCategory: '課程類別',
    instructor: '講師',
    credits: '學分數',
    courseLevel: '課程等級',
    certificateIssuance: '證書發放',
    hasCertificate: '有證書',
    unit: '單元',
    notes: '筆記',
    handout: '講義',
    supplementaryMaterials: '補充教材',
    personalNotes: '個人筆記',
    noSupplementaryMaterials: '此章節暫無補充教材',
    expandChapterList: '展開章節列表',
    collapseChapterList: '收合章節列表',
    expandNotesArea: '展開筆記區',
    collapseNotesArea: '收合筆記區',
    certificateAvailable: '有證書',
    noCertificate: '無證書',
    downloadPDFMaterials: '下載 PDF 教材',
    pdfMaterial: 'PDF 教材',
    downloadPdf: '下載 PDF',
    chapter: '章節',
    lesson: '課程',
    continueWatching: '繼續觀看',
    autoReturnInSeconds: '若未點擊，{seconds} 秒後將自動返回課程頁面',
    areYouStillWatching: '您還在觀看嗎？',
    clickContinueWatching: '請點擊「繼續觀看」按鈕確認您仍在觀看課程。',
    continueWatchingButton: '繼續觀看',
    noteTitlePlaceholder: '請輸入筆記標題',
    noteContentPlaceholder: '請輸入筆記內容',
    pleaseEnterNoteContent: '請輸入筆記內容',
    updating: '更新中',
    saving: '儲存中',
    saveNote: '儲存筆記',
    deleteFailed: '刪除失敗',
    save: '儲存',
    cancel: '取消',
    editNote: '編輯筆記',
    deleteNote: '刪除筆記',
    noteTimePoint: '筆記時間點',
    noteActions: '筆記操作',
    noteSaved: '筆記儲存成功',
    noteSaveFailed: '筆記儲存失敗',
    noteDeleted: '筆記刪除成功',
    noteDeleteFailed: '筆記刪除失敗',
    noteUpdated: '筆記更新成功',
    noteUpdateFailed: '筆記更新失敗',
    noteTitleRequired: '筆記標題為必填',
    noteContentRequired: '筆記內容為必填',
    noteTimeRequired: '筆記時間點為必填',
    jumpToTime: '跳轉到 {time}',
    notesCount: '{count} 筆記',
    noNotes: '尚無筆記',
    editingNote: '編輯筆記',
    update: '更新',
    addNote: '新增筆記',
    notesArea: '筆記區',
    chapterList: '章節列表',
    courseInfo: '課程資訊',
    videoPlayer: '影片播放器',
    materialsArea: '教材區',
    returnToCourse: '返回課程',
    previousChapter: '上一章節',
    nextChapter: '下一章節',
    loadingVideo: '載入影片中...',
    videoLoadError: '影片載入失敗',
    networkError: '網路錯誤，請檢查連線',
    serverError: '伺服器錯誤，請稍後再試',
    unauthorized: '請登入以存取此課程',
    courseNotFound: '找不到課程',
    chapterNotFound: '找不到章節',
    invalidCourseData: '無效的課程資料',
    fetchCourseError: '獲取課程資訊失敗',
    fetchProgressError: '獲取學習進度失敗',
    updateProgressError: '更新學習進度失敗',
    saveProgressError: '儲存學習進度失敗',
    courseCompleted: '課程已完成！',
    chapterCompleted: '章節已完成！',
    congratulation: '恭喜！',
    youHaveCompleted: '您已完成此課程',
    returnToDashboard: '返回儀表板',
    continueLearning: '繼續學習',
    learningProgress: '學習進度',
    completedChapters: '已完成章節',
    totalChapters: '總章節數',
    progressPercentage: '進度：{percentage}%',
    estimatedTime: '預估時間：{time}',
    actualTime: '實際時間：{time}',
    timeFormat: '{hours}時 {minutes}分 {seconds}秒',
    timeFormatShort: '{hours}:{minutes}:{seconds}',
    quiz: '測驗',
    completionProgress: '完課進度',
    completedViewProgress: '已完成！檢視進度',
    is_mandatory: '是否為必修課程',
    mandatory: '必修',
    optional: '選修',
    cameraNotEnabledError: '相機未啟用，請確認相機已正確連接',
    cameraPermissionError: '無法取得相機權限，請確認網站已被允許使用相機',
    cameraProblemError: '相機問題，請檢查權限設定',
    quizNotStarted: '尚未開始觀看',
    quizWatching: '觀看中',
    quizUnlocked: '解鎖測驗',
    quizLockedButton: '完成觀看以解鎖測驗',
    quizStartButton: '開始測驗',
    cameraPermissionRequired: '請允許網站使用相機權限',
    cameraNotFoundError: '找不到相機裝置，請確認相機已連接',
    cameraDisconnectedError: '相機已斷線，課程將自動結束',
    cameraNotStarted: '相機未啟動',
    cameraDisabled: '相機已停用',
    cannotCreatePhoto: '無法建立照片',
    cameraAbnormalAlert: '相機異常警示',
    cameraAbnormalContent: '偵測到相機異常（黑畫面），請檢查：移除相機鏡頭蓋或遮擋物，確保相機未被遮蔽，確認相機是否正常運作。課程監控將繼續使用目前照片進行記錄。',
    cannotGetValidPhoto: '無法取得有效照片',
    autoExitDueToInactivity: '因長時間無活動而自動退出觀看'
  },
  courseViewWithoutReg: {
    noVideoContent: '此章節暫無影片內容',
    courseTitle: '課程標題',
    courseCategory: '課程類別',
    credits: '學分數',
    courseLevel: '課程等級',
    certificateIssuance: '證書發放',
    instructor: '講師',
    unit: '單元',
    is_mandatory: '是否為必修課程',
    mandatory: '必修',
    optional: '選修',
    handout: '講義',
    downloadPDFMaterials: '下載 PDF 教材',
    downloadPdf: '下載 PDF',
    chapter: '章節',
    lesson: '課程',
    noSupplementaryMaterials: '此章節暫無補充教材',
    expandChapterList: '展開章節列表',
    collapseChapterList: '收合章節列表',
    expandNotesArea: '展開筆記區',
    collapseNotesArea: '收合筆記區',
    certificateAvailable: '有證書',
    noCertificate: '無證書',
    courseInfo: '課程資訊',
    videoPlayer: '影片播放器',
    materialsArea: '教材區',
    chapterList: '章節列表',
    returnToCourse: '返回課程',
    previousChapter: '上一章節',
    nextChapter: '下一章節',
    loadingVideo: '載入影片中...',
    videoLoadError: '影片載入失敗',
    networkError: '網路錯誤，請檢查連線',
    serverError: '伺服器錯誤，請稍後再試',
    courseNotFound: '找不到課程',
    chapterNotFound: '找不到章節',
    invalidCourseData: '無效的課程資料',
    fetchCourseError: '獲取課程資訊失敗',
    unauthorized: '請登入以存取完整課程內容',
    previewMode: '預覽模式',
    previewModeDesc: '您目前處於預覽模式。註冊以存取完整課程內容。',
    registerNow: '立即註冊',
    alreadyHaveAccount: '已經有帳號了嗎？',
    loginHere: '在此登入',
    freePreview: '免費預覽',
    fullCourseAccess: '完整課程存取',
    featuresComparison: '功能比較',
    previewFeatures: '預覽功能',
    fullFeatures: '完整功能',
    watchVideos: '觀看影片',
    viewMaterials: '查看教材',
    takeNotes: '做筆記',
    earnCertificate: '獲得證書',
    trackProgress: '追蹤進度',
    lifetimeAccess: '終生存取',
    mobileFriendly: '手機友善',
    customerSupport: '客戶支援',
    creditsUnit: '學分',
    play: '播放',
    selectChapterToStart: '請從左側選擇一個章節開始學習',
    expand: '展開',
    collapse: '收合',
    courseVideo: '課程影片',
    noChapterContent: '此課程暫無章節內容，將返回課程詳細頁面',
    notSpecified: '未指定',
    unableToGetCourseData: '無法獲取課程數據',
    loadCourseFailed: '載入課程失敗，請重試'
  },
  // 2026-08-06：簡訊認證取代信箱認證
  smsAuth: {
    registerTitle: '請輸入手機驗證碼',
    registerSubtitle: '已將驗證碼寄送至您的手機 {phone}',
    resetTitle: '重設密碼',
    resetSubtitle: '請輸入手機收到的驗證碼以重設密碼',
    phoneLabel: '手機號碼',
    phonePlaceholder: '請輸入手機號碼（例：0912345678）',
    codeLabel: '6 位數驗證碼',
    codePlaceholder: '請輸入簡訊中的 6 位數驗證碼',
    sendCode: '發送驗證碼',
    submitCode: '送出驗證碼',
    resendCode: '重新發送驗證碼',
    resendSuccess: '驗證碼已重新發送',
    resendIn: '{seconds} 秒後可重發',
    bindTitle: '補綁手機號碼',
    bindSubtitle: '依系統要求，請補綁您的手機號碼以繼續使用服務',
    bindSubmit: '完成綁定',
    newPasswordLabel: '新密碼',
    newPasswordPlaceholder: '請輸入新密碼',
    confirmPasswordLabel: '確認新密碼',
    confirmPasswordPlaceholder: '請再次輸入新密碼',
    resetSubmit: '重設密碼',
    helpText: '沒有收到？請檢查手機訊息中心或聯絡客服',
    errorPhoneFormat: '手機號碼格式錯誤，請輸入正確的號碼',
    errorCodeInvalid: '驗證碼錯誤或已過期',
    errorCodeExpired: '驗證碼已過期，請重新發送',
    errorRateLimit: '操作太頻繁，請稍後再試',
    errorPhoneAlreadyUsed: '此手機號碼已被使用',
    errorPhoneNotBound: '此手機號碼未綁定任何帳號',
    errorEmailMissing: '找不到註冊 email，請重新註冊',
    successRegister: '手機驗證成功，帳號已啟用',
    successReset: '密碼重設成功，請使用新密碼登入',
    successBind: '手機綁定成功'
  }
};

export default replaceBrand(messages);
